import { Component, Vue } from 'vue-property-decorator'
import CAJG1040Service from './CAJG1040Service'
import CAJG1040ViewModel from './CAJG1040ViewModel'
import { XSSFilterOptions } from '@/common/XSSFilterOptions'
import '@/assets/css/colorbox.css'
import CommonConstants from '@/common/CommonConstants'
import TransportService from '@/common/TransportService'
import CommonUtil from '@/common/utils/CommonUtil'
import { DigitalBookButton } from '@/common/utils/modules-util'
import { fixedContent } from '@/assets/js/main.js'
import ColorBox from '@/assets/js/components/colorbox.js'
@Component({
  name: 'CAJG1040',
  components: {}
  })
export default class CAJG1040Controller extends Vue {
  private XSSFilterOptions = XSSFilterOptions
  private cajg1040ViewModel: CAJG1040ViewModel = {
    seminarVideoHtmlInfo: {
      content: ''
    }
  }

  private cajg1040Service: CAJG1040Service = new CAJG1040Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    this.$nextTick(() => {
      const digitalBookButton = new DigitalBookButton('.js-digital-book')
      ColorBox()
    })
  }

  /**
   * 初期処理
   */
  private async init() {
    const [caja1040ResponseModel] = await Promise.all([
      this.cajg1040Service.callAPICAJA1040(),
      // システムアクティビティログを実行する（トランスポート）
      TransportService.callAPITransport(CommonConstants.URL_CAJG1040, null, null)
    ])
    if (CommonUtil.isNotEmpty(caja1040ResponseModel.seminarVideoHtmlInfo)) {
      this.cajg1040ViewModel.seminarVideoHtmlInfo.content =
        CommonUtil.replacePathCMS(
          caja1040ResponseModel.seminarVideoHtmlInfo.content,
          CommonConstants.TEMPLATE_CMS_PATH,
          caja1040ResponseModel.seminarVideoHtmlInfo.path
        )
    } else {
      this.cajg1040ViewModel.seminarVideoHtmlInfo = null
    }
  }

  /**
   * 学習メニュートップ（ログイン後）(CAJG1060 )画面に遷移する。
   */
  private gotoCAJG1060() {
    this.$router.push({ name: 'cajg1060' })
  }
}
